import { render, staticRenderFns } from "./SettingsChecklist.vue?vue&type=template&id=501c4697&scoped=true&"
import script from "./SettingsChecklist.vue?vue&type=script&lang=ts&"
export * from "./SettingsChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501c4697",
  null
  
)

export default component.exports